/**
 * Todos plugin manifest — enables rich detail view for todos.
 * Registers TodoDetailView renderer for standard todo types.
 */

import { PluginRegistration } from '@/infra/plugin-registry';
import { TodoDetailView } from './components/TodoDetailView';

export const todosManifest: PluginRegistration = {
  id: 'todos',
  display_name: 'Todos',
  description: 'Core todos feature with rich metadata display',
  version: '1.0.0',
  enabled_by_default: true,
  todo_types: [
    {
      type_tag: 'standard.todo',
      label: 'Standard Todo',
    },
    {
      type_tag: 'claude.todo',
      label: 'Claude Todo',
    },
  ],
  web_routes: [],
  todoRenderers: {
    'standard.todo': TodoDetailView,
    'claude.todo': TodoDetailView,
  },
};
